let notice = document.querySelector('.notice');
let noticeButton = document.querySelector('.notice__close');

if (noticeButton) {
  noticeButton.addEventListener('click', noticeButtonClickHandler);
}

function noticeButtonClickHandler() {
  notice.remove();
  noticeButton.removeEventListener('click', noticeButtonClickHandler);
}
